import type { Control, FieldPath, FieldValues } from "react-hook-form";

import { Controller } from "react-hook-form";

import type { TiptapEditorProps } from "@/components/ui/TiptapEditor";

import { TiptapEditor } from "@/components/ui/TiptapEditor";

interface ControlledTiptapEditorProps<T extends FieldValues>
  extends Omit<TiptapEditorProps, "name" | "onChange"> {
  changeInternalState?: boolean;
  control: Control<T>;
  name: FieldPath<T>;
  onChangeHTML?: (html: string) => void;
  onChangeText?: (text: string) => void;
  placeholder?: string;
}

export function ControlledTipTapEditor<T extends FieldValues>({
  changeInternalState = false,
  control,
  name,
  onChangeHTML,
  onChangeText,
  placeholder,
  ...props
}: ControlledTiptapEditorProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <TiptapEditor
          {...props}
          errorMessage={error?.message}
          isInvalid={!!error}
          isPending={changeInternalState}
          onChange={(value) => {
            onChangeText?.(value);
          }}
          onChangeHTML={(html) => {
            if (onChangeHTML) {
              onChangeHTML?.(html);

              return;
            }
            field.onChange(html);
          }}
          placeholder={placeholder}
          value={field.value}
        />
      )}
    />
  );
}
